module.exports = __webpack_public_path__ + "media/brand_logos/toyota-8b040e64.png";